"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectSerializer = void 0;
__exportStar(require("./Auth"), exports);
__exportStar(require("./BusinessInvoice"), exports);
__exportStar(require("./Creator"), exports);
__exportStar(require("./CreatorCreatorAppearInAdSurveys"), exports);
__exportStar(require("./EntriesEntry"), exports);
__exportStar(require("./EntriesPlatform"), exports);
__exportStar(require("./EntriesScoutHashGroupEntry"), exports);
__exportStar(require("./EntriesScoutHashGroupEntryChildEntriesAttributes"), exports);
__exportStar(require("./EntriesScoutHashSoloEntry"), exports);
__exportStar(require("./Entry"), exports);
__exportStar(require("./EntryEntry"), exports);
__exportStar(require("./EntryPlatform"), exports);
__exportStar(require("./InlineObject"), exports);
__exportStar(require("./InlineObject1"), exports);
__exportStar(require("./InlineObject2"), exports);
__exportStar(require("./InlineObject3"), exports);
__exportStar(require("./InlineObject4"), exports);
__exportStar(require("./InlineObject5"), exports);
__exportStar(require("./InlineObject6"), exports);
__exportStar(require("./InlineObject7"), exports);
__exportStar(require("./InlineResponse200"), exports);
__exportStar(require("./InlineResponse2001"), exports);
__exportStar(require("./InlineResponse2002"), exports);
__exportStar(require("./InlineResponse400"), exports);
__exportStar(require("./InlineResponse4001"), exports);
__exportStar(require("./InlineResponse404"), exports);
__exportStar(require("./InlineResponse4041"), exports);
__exportStar(require("./InlineResponse4042"), exports);
__exportStar(require("./InlineResponse409"), exports);
__exportStar(require("./InlineResponse4091"), exports);
__exportStar(require("./InlineResponse422"), exports);
__exportStar(require("./InlineResponse4221"), exports);
__exportStar(require("./InlineResponse4222"), exports);
__exportStar(require("./LiveStreamingEntriesEntry"), exports);
__exportStar(require("./LiveStreamingServices"), exports);
__exportStar(require("./LiveStreamingServicesLiveStreamingServices"), exports);
__exportStar(require("./MypageTermsAgreeToTermsTerm"), exports);
__exportStar(require("./Payee"), exports);
__exportStar(require("./Revenue"), exports);
__exportStar(require("./RevenueLastMonthCarryOveredRevenues"), exports);
__exportStar(require("./RevenueThisMonthRevenues"), exports);
__exportStar(require("./Revenues"), exports);
__exportStar(require("./RevenuesRevenues"), exports);
__exportStar(require("./Terms"), exports);
var Auth_1 = require("./Auth");
var BusinessInvoice_1 = require("./BusinessInvoice");
var Creator_1 = require("./Creator");
var CreatorCreatorAppearInAdSurveys_1 = require("./CreatorCreatorAppearInAdSurveys");
var EntriesEntry_1 = require("./EntriesEntry");
var EntriesPlatform_1 = require("./EntriesPlatform");
var EntriesScoutHashGroupEntry_1 = require("./EntriesScoutHashGroupEntry");
var EntriesScoutHashGroupEntryChildEntriesAttributes_1 = require("./EntriesScoutHashGroupEntryChildEntriesAttributes");
var EntriesScoutHashSoloEntry_1 = require("./EntriesScoutHashSoloEntry");
var Entry_1 = require("./Entry");
var EntryEntry_1 = require("./EntryEntry");
var EntryPlatform_1 = require("./EntryPlatform");
var InlineObject_1 = require("./InlineObject");
var InlineObject1_1 = require("./InlineObject1");
var InlineObject2_1 = require("./InlineObject2");
var InlineObject3_1 = require("./InlineObject3");
var InlineObject4_1 = require("./InlineObject4");
var InlineObject5_1 = require("./InlineObject5");
var InlineObject6_1 = require("./InlineObject6");
var InlineObject7_1 = require("./InlineObject7");
var InlineResponse200_1 = require("./InlineResponse200");
var InlineResponse2001_1 = require("./InlineResponse2001");
var InlineResponse2002_1 = require("./InlineResponse2002");
var InlineResponse400_1 = require("./InlineResponse400");
var InlineResponse4001_1 = require("./InlineResponse4001");
var InlineResponse404_1 = require("./InlineResponse404");
var InlineResponse4041_1 = require("./InlineResponse4041");
var InlineResponse4042_1 = require("./InlineResponse4042");
var InlineResponse409_1 = require("./InlineResponse409");
var InlineResponse4091_1 = require("./InlineResponse4091");
var InlineResponse422_1 = require("./InlineResponse422");
var InlineResponse4221_1 = require("./InlineResponse4221");
var InlineResponse4222_1 = require("./InlineResponse4222");
var LiveStreamingEntriesEntry_1 = require("./LiveStreamingEntriesEntry");
var LiveStreamingServices_1 = require("./LiveStreamingServices");
var LiveStreamingServicesLiveStreamingServices_1 = require("./LiveStreamingServicesLiveStreamingServices");
var MypageTermsAgreeToTermsTerm_1 = require("./MypageTermsAgreeToTermsTerm");
var Payee_1 = require("./Payee");
var Revenue_1 = require("./Revenue");
var RevenueLastMonthCarryOveredRevenues_1 = require("./RevenueLastMonthCarryOveredRevenues");
var RevenueThisMonthRevenues_1 = require("./RevenueThisMonthRevenues");
var Revenues_1 = require("./Revenues");
var RevenuesRevenues_1 = require("./RevenuesRevenues");
var Terms_1 = require("./Terms");
var primitives = [
    "string",
    "boolean",
    "double",
    "integer",
    "long",
    "float",
    "number",
    "any"
];
var supportedMediaTypes = {
    "application/json": Infinity,
    "application/octet-stream": 0,
    "application/x-www-form-urlencoded": 0
};
var enumsMap = new Set([
    "BusinessInvoiceBusinessInvoiceStatusEnum",
    "CreatorParentRelationshipEnum",
    "CreatorCreatorTypeEnum",
    "CreatorAvailableServicesEnum",
    "CreatorCreatorAppearInAdSurveysRatingEnum",
    "EntriesEntryEntryTypeEnum",
    "EntriesEntryEntryRouteEnum",
    "EntriesScoutHashGroupEntryAccountTypeEnum",
    "EntriesScoutHashGroupEntryChildEntriesAttributesParentRelationshipEnum",
    "EntriesScoutHashSoloEntryAccountTypeEnum",
    "EntriesScoutHashSoloEntryParentRelationshipEnum",
    "EntryEntryEntryTypeEnum",
    "EntryEntryEntryRouteEnum",
    "InlineObjectParentRelationshipEnum",
    "InlineObject1AccountTypeEnum",
    "InlineResponse2002RatingEnum",
    "LiveStreamingEntriesEntryEntryRouteEnum",
    "LiveStreamingEntriesEntryAuthProviderEnum",
    "LiveStreamingEntriesEntryInflowRouteEnum",
    "PayeePaymentMethodEnum",
]);
var typeMap = {
    "Auth": Auth_1.Auth,
    "BusinessInvoice": BusinessInvoice_1.BusinessInvoice,
    "Creator": Creator_1.Creator,
    "CreatorCreatorAppearInAdSurveys": CreatorCreatorAppearInAdSurveys_1.CreatorCreatorAppearInAdSurveys,
    "EntriesEntry": EntriesEntry_1.EntriesEntry,
    "EntriesPlatform": EntriesPlatform_1.EntriesPlatform,
    "EntriesScoutHashGroupEntry": EntriesScoutHashGroupEntry_1.EntriesScoutHashGroupEntry,
    "EntriesScoutHashGroupEntryChildEntriesAttributes": EntriesScoutHashGroupEntryChildEntriesAttributes_1.EntriesScoutHashGroupEntryChildEntriesAttributes,
    "EntriesScoutHashSoloEntry": EntriesScoutHashSoloEntry_1.EntriesScoutHashSoloEntry,
    "Entry": Entry_1.Entry,
    "EntryEntry": EntryEntry_1.EntryEntry,
    "EntryPlatform": EntryPlatform_1.EntryPlatform,
    "InlineObject": InlineObject_1.InlineObject,
    "InlineObject1": InlineObject1_1.InlineObject1,
    "InlineObject2": InlineObject2_1.InlineObject2,
    "InlineObject3": InlineObject3_1.InlineObject3,
    "InlineObject4": InlineObject4_1.InlineObject4,
    "InlineObject5": InlineObject5_1.InlineObject5,
    "InlineObject6": InlineObject6_1.InlineObject6,
    "InlineObject7": InlineObject7_1.InlineObject7,
    "InlineResponse200": InlineResponse200_1.InlineResponse200,
    "InlineResponse2001": InlineResponse2001_1.InlineResponse2001,
    "InlineResponse2002": InlineResponse2002_1.InlineResponse2002,
    "InlineResponse400": InlineResponse400_1.InlineResponse400,
    "InlineResponse4001": InlineResponse4001_1.InlineResponse4001,
    "InlineResponse404": InlineResponse404_1.InlineResponse404,
    "InlineResponse4041": InlineResponse4041_1.InlineResponse4041,
    "InlineResponse4042": InlineResponse4042_1.InlineResponse4042,
    "InlineResponse409": InlineResponse409_1.InlineResponse409,
    "InlineResponse4091": InlineResponse4091_1.InlineResponse4091,
    "InlineResponse422": InlineResponse422_1.InlineResponse422,
    "InlineResponse4221": InlineResponse4221_1.InlineResponse4221,
    "InlineResponse4222": InlineResponse4222_1.InlineResponse4222,
    "LiveStreamingEntriesEntry": LiveStreamingEntriesEntry_1.LiveStreamingEntriesEntry,
    "LiveStreamingServices": LiveStreamingServices_1.LiveStreamingServices,
    "LiveStreamingServicesLiveStreamingServices": LiveStreamingServicesLiveStreamingServices_1.LiveStreamingServicesLiveStreamingServices,
    "MypageTermsAgreeToTermsTerm": MypageTermsAgreeToTermsTerm_1.MypageTermsAgreeToTermsTerm,
    "Payee": Payee_1.Payee,
    "Revenue": Revenue_1.Revenue,
    "RevenueLastMonthCarryOveredRevenues": RevenueLastMonthCarryOveredRevenues_1.RevenueLastMonthCarryOveredRevenues,
    "RevenueThisMonthRevenues": RevenueThisMonthRevenues_1.RevenueThisMonthRevenues,
    "Revenues": Revenues_1.Revenues,
    "RevenuesRevenues": RevenuesRevenues_1.RevenuesRevenues,
    "Terms": Terms_1.Terms,
};
var ObjectSerializer = (function () {
    function ObjectSerializer() {
    }
    ObjectSerializer.findCorrectType = function (data, expectedType) {
        if (data == undefined) {
            return expectedType;
        }
        else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        }
        else if (expectedType === "Date") {
            return expectedType;
        }
        else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }
            if (!typeMap[expectedType]) {
                return expectedType;
            }
            var discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType;
            }
            else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    if (typeMap[discriminatorType]) {
                        return discriminatorType;
                    }
                    else {
                        return expectedType;
                    }
                }
                else {
                    return expectedType;
                }
            }
        }
    };
    ObjectSerializer.serialize = function (data, type, format) {
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            var subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            var transformedData = [];
            for (var index in data) {
                var date = data[index];
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            if (format == "date") {
                var month = data.getMonth() + 1;
                month = month < 10 ? "0" + month.toString() : month.toString();
                var day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();
                return data.getFullYear() + "-" + month + "-" + day;
            }
            else {
                return data.toISOString();
            }
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            type = this.findCorrectType(data, type);
            var attributeTypes = typeMap[type].getAttributeTypeMap();
            var instance = {};
            for (var index in attributeTypes) {
                var attributeType = attributeTypes[index];
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    };
    ObjectSerializer.deserialize = function (data, type, format) {
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            var subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            var transformedData = [];
            for (var index in data) {
                var date = data[index];
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            return new Date(data);
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            var instance = new typeMap[type]();
            var attributeTypes = typeMap[type].getAttributeTypeMap();
            for (var index in attributeTypes) {
                var attributeType = attributeTypes[index];
                instance[attributeType.name] = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
            }
            return instance;
        }
    };
    ObjectSerializer.normalizeMediaType = function (mediaType) {
        if (mediaType === undefined) {
            return undefined;
        }
        return mediaType.split(";")[0].trim().toLowerCase();
    };
    ObjectSerializer.getPreferredMediaType = function (mediaTypes) {
        if (!mediaTypes) {
            return "application/json";
        }
        var normalMediaTypes = mediaTypes.map(this.normalizeMediaType);
        var selectedMediaType = undefined;
        var selectedRank = -Infinity;
        for (var _i = 0, normalMediaTypes_1 = normalMediaTypes; _i < normalMediaTypes_1.length; _i++) {
            var mediaType = normalMediaTypes_1[_i];
            if (supportedMediaTypes[mediaType] > selectedRank) {
                selectedMediaType = mediaType;
                selectedRank = supportedMediaTypes[mediaType];
            }
        }
        if (selectedMediaType === undefined) {
            throw new Error("None of the given media types are supported: " + mediaTypes.join(", "));
        }
        return selectedMediaType;
    };
    ObjectSerializer.stringify = function (data, mediaType) {
        if (mediaType === "application/json") {
            return JSON.stringify(data);
        }
        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.stringify.");
    };
    ObjectSerializer.parse = function (rawData, mediaType) {
        if (mediaType === undefined) {
            throw new Error("Cannot parse content. No Content-Type defined.");
        }
        if (mediaType === "application/json") {
            return JSON.parse(rawData);
        }
        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.parse.");
    };
    return ObjectSerializer;
}());
exports.ObjectSerializer = ObjectSerializer;
//# sourceMappingURL=ObjectSerializer.js.map